var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { createRef } from 'react';
import { observer } from 'mobx-react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { CardFooter, Col, Row, Card, CardBody, NavItem, Nav, NavLink } from 'reactstrap';
import Select from 'react-select';
import classNames from 'classnames';
import Page from '../Page';
import DateRange from "../../components/ui/DateRange/DateRange";
import { ApplicationContext } from '../../../ApplicationContext';
import DateRangePreset, { getDateRangeFromPreset } from "../../../data/DateRangePreset";
import MeasurementCollection from "../../../collections/metrics/MeasurementCollection";
import MeasurementSearch from "../../components/ui/MeasurementSearch/MeasurementSearch";
import AssetSearch from "../../components/ui/AssetSearch/AssetSearch";
import GetAllMeasurementsCommand from "../../../commands/metrics/GetAllMeasurementsCommand";
import GetAvailableMeasurementsCommand from "../../../commands/metrics/GetAvailableMeasurementsCommand";
import GetSamplesCommand from "../../../commands/metrics/GetSamplesCommand";
import { ChartColors } from "../../../data/ChartColors";
import SampleCollection from "../../../collections/metrics/SampleCollection";
import SampleMetaDataCollection from "../../../collections/metrics/SampleMetaDataCollection";
import { getEnumKeys } from "../../../utils/enumUtils";
import CardTitleHeader from "../../components/ui/Cards/CardTitleHeader";
import CollapsableCard from "../../components/ui/Cards/CollapsableCard";
import MetricsGraphs from "./MetricsGraphs";
import { MetricsIntervalType } from "../../../data/MetricsIntervalType";
import MetricsTables from "./MetricsTables";
import { EmptyDiv } from "../../components/ui/EmptyDiv/EmptyDiv";
import { SensorProviderCheck } from "../../../utils/HideBatteryVoltageSampleHelper";
var VIEW_STATE_CHART = 'view_state_chart';
var VIEW_STATE_TABLE = 'view_state_table';
/**
 *
 */
var Metrics = /** @class */ (function (_super) {
    __extends(Metrics, _super);
    /**
     *
     */
    function Metrics(props) {
        var _this = _super.call(this, props) || this;
        _this.onDateRangeSelected = _this.onDateRangeSelected.bind(_this);
        _this.onDateRangeChanged = _this.onDateRangeChanged.bind(_this);
        _this.retrieveSamples = _this.retrieveSamples.bind(_this);
        _this.dateRangePresetOptions = Object.keys(DateRangePreset).map(function (key) {
            return {
                value: key,
                label: props.intl.formatMessage({ id: DateRangePreset[key].labelId }),
                preset: DateRangePreset[key]
            };
        });
        _this.dateRangePresetOptions.push({
            value: 'custom',
            label: props.intl.formatMessage({ id: 'daterange.preset.days.custom' }),
            preset: null
        });
        _this.metricsIntervalRef = createRef();
        _this.state = {
            measurementCollection: new MeasurementCollection(),
            sampleCollection: new SampleCollection(),
            sampleMetaDataCollection: new SampleMetaDataCollection(),
            selectedDateRangePreset: DateRangePreset.MONTH_CURRENT,
            selectedDateRange: getDateRangeFromPreset(DateRangePreset.MONTH_CURRENT),
            selectedAssets: [],
            selectedMeasurements: [],
            showAllMeasurements: false,
            chartsData: [],
            interval: MetricsIntervalType.DAY,
            activeTab: 0,
            activeTabName: null,
            viewState: VIEW_STATE_CHART
        };
        return _this;
    }
    /**
     *
     */
    Metrics.prototype.componentDidMount = function () {
        this.initialize();
    };
    /**
     *
     */
    Metrics.prototype.initialize = function () {
        var _this = this;
        var _a = this.state, showAllMeasurements = _a.showAllMeasurements, selectedAssets = _a.selectedAssets;
        if (showAllMeasurements) {
            var command = new GetAllMeasurementsCommand();
            command.execute(this.context.session.user.organisation, this.state.measurementCollection);
        }
        else {
            var command = new GetAvailableMeasurementsCommand();
            command.execute(this.context.session.user.organisation, selectedAssets, this.state.measurementCollection).then(function () {
                var allSensorProvider = false;
                selectedAssets.map(function (asset) {
                    return allSensorProvider = allSensorProvider || SensorProviderCheck(asset);
                });
                if (allSensorProvider) {
                    _this.state.measurementCollection.remove(_this.state.measurementCollection.find("name", "BatteryVoltage"));
                }
            });
        }
    };
    /**
     *
     * @returns {*}
     */
    Metrics.prototype.render = function () {
        var _this = this;
        var session = this.context.session;
        var intl = this.props.intl;
        var _a = this.state, selectedDateRangePreset = _a.selectedDateRangePreset, selectedDateRange = _a.selectedDateRange, measurementCollection = _a.measurementCollection, chartsData = _a.chartsData, interval = _a.interval, activeTab = _a.activeTab, viewState = _a.viewState, activeTabName = _a.activeTabName;
        if (!session.isLoggedIn) {
            return null;
        }
        var dateRange = getDateRangeFromPreset(selectedDateRangePreset);
        if (!dateRange) {
            dateRange = selectedDateRange;
        }
        return (React.createElement(Page, { pageName: "metrics pb-4" },
            React.createElement("div", { className: "pb-4" },
                React.createElement("div", { className: "card mb-0", style: { width: "95%", borderRadius: "0px 20px 20px 0px" } },
                    React.createElement("div", { className: "card-header align-items-start flex-grow-0 pb-0" },
                        React.createElement("div", { className: "d-flex justify-content-between mb-4 pr-3 flex-wrap" },
                            React.createElement("h1", { className: 'header-title align-self-center order-0 mr-3' },
                                React.createElement(FormattedMessage, { id: "page.metrics.title" })))),
                    React.createElement("div", { className: "card-body pb-0" },
                        React.createElement(CollapsableCard, { className: "bg-white", collapsed: chartsData.length > 0 },
                            React.createElement(CardTitleHeader, { title: intl.formatMessage({ id: 'page.metrics.settings.title' }), children: React.createElement("div", null) }),
                            React.createElement(CardBody, null,
                                React.createElement("div", { className: "d-flex justify-content-between flex-wrap settings-selection", style: { columnGap: "2em" } },
                                    React.createElement("div", { className: "flex-fill", style: { maxWidth: "40%" } },
                                        React.createElement("label", { className: "font-weight-bold" },
                                            React.createElement(FormattedMessage, { id: "asset.search.label" })),
                                        React.createElement(AssetSearch, { assetCollection: this.context.assetCollection, isMulti: true, onChange: function (models) {
                                                _this.setState({ selectedAssets: models }, _this.initialize);
                                            } })),
                                    this.canSelectMeasurements() &&
                                        React.createElement("div", { className: "flex-fill", style: { maxWidth: "40%" } },
                                            React.createElement("label", { className: "font-weight-bold" },
                                                React.createElement(FormattedMessage, { id: "measurement.search.label" })),
                                            React.createElement("div", { className: "d-flex align-items-center" },
                                                React.createElement(MeasurementSearch, { measurementCollection: measurementCollection, isMulti: true, onChange: function (models) {
                                                        _this.setState({ selectedMeasurements: models });
                                                    } }))),
                                    this.canSetDateRange() &&
                                        React.createElement(React.Fragment, null,
                                            React.createElement("div", { className: "w-15" },
                                                React.createElement("label", { className: "font-weight-bold" },
                                                    React.createElement(FormattedMessage, { id: "daterange.label.preset" })),
                                                React.createElement(Select, { className: "form-control select2 mb-3", classNamePrefix: "select2", options: this.dateRangePresetOptions, defaultValue: this.dateRangePresetOptions[2], onChange: this.onDateRangeSelected })),
                                            !selectedDateRangePreset &&
                                                React.createElement("div", null,
                                                    React.createElement(DateRange, { onChange: this.onDateRangeChanged, startDate: dateRange[0], endDate: dateRange[1] }))))),
                            React.createElement(CardFooter, null,
                                React.createElement(Row, null,
                                    React.createElement(Col, { className: "d-flex justify-content-end" },
                                        React.createElement("button", { className: "btn btn-primary", onClick: this.retrieveSamples, disabled: !this.canRetrieveSamples() },
                                            React.createElement(FormattedMessage, { id: "page.metrics.generate" })))))),
                        this.hasSamples() &&
                            React.createElement(Card, { className: "bg-white" },
                                React.createElement(CardTitleHeader, { title: intl.formatMessage({ id: "page.metrics.charts.title" }) },
                                    React.createElement("div", { className: "d-flex align-items-center" },
                                        React.createElement(Nav, { tabs: true, className: "mb-3" }, chartsData.map(function (datasets, index) {
                                            return React.createElement(NavItem, { key: index },
                                                React.createElement(NavLink, { className: classNames({ active: _this.state.activeTab === index }), onClick: function () {
                                                        _this.setState({
                                                            activeTab: index,
                                                            activeTabName: datasets[0].name
                                                        });
                                                    } }, datasets[0].name));
                                        })),
                                        React.createElement("div", { className: "nav btn-group d-inline-flex flex-nowrap ml-4" },
                                            React.createElement("button", { className: 'btn btn-white' + (viewState === VIEW_STATE_TABLE ? ' active' : ''), onClick: function () {
                                                    _this.setState({ viewState: VIEW_STATE_TABLE });
                                                } },
                                                React.createElement("span", { className: "fe fe-list" })),
                                            React.createElement("button", { className: 'btn btn-white ' + (viewState === VIEW_STATE_CHART ? ' active' : ''), onClick: function () {
                                                    _this.setState({ viewState: VIEW_STATE_CHART });
                                                } },
                                                React.createElement("span", { className: "fe fe-bar-chart-2" }))))),
                                React.createElement(CardBody, null,
                                    viewState === VIEW_STATE_CHART && chartsData.length > 0 ?
                                        React.createElement(MetricsGraphs, { chartsData: chartsData, unit: interval.toLowerCase(), activeTab: activeTab, name: activeTabName }) : null,
                                    viewState === VIEW_STATE_TABLE && chartsData.length > 0 ?
                                        React.createElement(MetricsTables, { chartsData: chartsData, activeTab: activeTab }) : null,
                                    chartsData.length === 0 && React.createElement(EmptyDiv, null))))))));
    };
    /**
     *
     */
    Metrics.prototype.retrieveSamples = function () {
        var _this = this;
        var session = this.context.session;
        var _a = this.state, selectedDateRange = _a.selectedDateRange, selectedAssets = _a.selectedAssets, selectedMeasurements = _a.selectedMeasurements, sampleMetaDataCollection = _a.sampleMetaDataCollection, sampleCollection = _a.sampleCollection, interval = _a.interval;
        var command = new GetSamplesCommand();
        var unit = interval.toLocaleLowerCase();
        var amount = 1;
        var intervalString = amount + ' ' + unit + (amount > 1 ? 's' : '');
        command.execute(session.user.organisation, sampleCollection, sampleMetaDataCollection, selectedAssets.map(function (asset) { return asset.getMetricsDbId(); }), selectedMeasurements.map(function (measurement) { return measurement.id; }), intervalString, { fromUnixTimeMillis: selectedDateRange[0].getTime(), toUnixTimeMillis: selectedDateRange[1].getTime() })
            .then(function () {
            var chartsData = _this.generateDatasets();
            _this.setState({ chartsData: chartsData, activeTab: 0, activeTabName: chartsData[0][0].name });
        });
    };
    Metrics.prototype.generateDatasets = function () {
        var intl = this.props.intl;
        var _a = this.state, selectedAssets = _a.selectedAssets, measurementCollection = _a.measurementCollection, sampleCollection = _a.sampleCollection;
        var chartsData = [];
        //
        if (sampleCollection.list.length > 0) {
            var batteryVoltageMeasurementId = "";
            var measurementIds_1 = [];
            var measurementModels_1 = [];
            measurementCollection.list.forEach(function (measurementModel) {
                if (measurementIds_1.indexOf(measurementModel.id) < 0) {
                    measurementIds_1.push(measurementModel.id);
                    measurementModels_1.push(measurementModel);
                }
            });
            var colors_1 = getEnumKeys(ChartColors).map(function (key) { return ChartColors[key]; });
            var colorIndex_1 = 0;
            // Create dataset per measurement type
            measurementIds_1.forEach(function (measurementId, measurementIndex) {
                var datasets = [];
                // Create datasets per assets
                selectedAssets.forEach(function (assetModel) {
                    //
                    var assetMetricsId = assetModel.getMetricsDbId();
                    var samples = sampleCollection.getSamplesForAssetAndMeasurement(assetMetricsId, measurementId);
                    // Only add when samples are found
                    if (samples.length > 0) {
                        datasets.push({
                            unit: measurementModels_1[measurementIndex].unit,
                            name: intl.formatMessage({
                                id: 'measurement.' + measurementModels_1[measurementIndex].name,
                                default: measurementModels_1[measurementIndex].name
                            }),
                            label: assetModel.id,
                            data: samples.map(function (sampleModel) {
                                return { x: sampleModel.timestamp, y: sampleModel.getNormalizedSampleValue() };
                            }),
                            fill: false,
                            backgroundColor: colors_1[colorIndex_1 % colors_1.length],
                            borderColor: colors_1[colorIndex_1 % colors_1.length]
                        });
                        colorIndex_1++;
                    }
                });
                if (datasets.length > 0) {
                    chartsData.push(datasets);
                }
            });
        }
        return chartsData;
    };
    /**
     *
     */
    Metrics.prototype.onDateRangeChanged = function (dates) {
        this.setState({ selectedDateRange: dates, selectedDateRangePreset: null });
    };
    /**
     *
     */
    Metrics.prototype.onDateRangeSelected = function (data) {
        var dateRange = getDateRangeFromPreset(data.preset);
        this.setState({ selectedDateRangePreset: data.preset });
        if (dateRange) {
            this.setState({ selectedDateRangePreset: data.preset, selectedDateRange: dateRange });
        }
        else {
            this.setState({ selectedDateRangePreset: data.preset });
        }
    };
    /**
     *
     * @param error
     */
    Metrics.prototype.onError = function (error) {
    };
    /**
     *
     */
    Metrics.prototype.canSelectMeasurements = function () {
        var selectedAssets = this.state.selectedAssets;
        return selectedAssets.length > 0;
    };
    /**
     *
     */
    Metrics.prototype.canSetDateRange = function () {
        var _a = this.state, selectedAssets = _a.selectedAssets, selectedMeasurements = _a.selectedMeasurements;
        return selectedAssets.length > 0 &&
            selectedMeasurements.length > 0;
    };
    /**
     *
     */
    Metrics.prototype.canRetrieveSamples = function () {
        var _a = this.state, selectedDateRange = _a.selectedDateRange, selectedAssets = _a.selectedAssets, selectedMeasurements = _a.selectedMeasurements;
        return !!selectedDateRange &&
            selectedAssets.length > 0 &&
            selectedMeasurements.length > 0;
    };
    /**
     *
     */
    Metrics.prototype.hasSamples = function () {
        return this.state.sampleCollection.list.length > 0;
    };
    Metrics = __decorate([
        observer
    ], Metrics);
    return Metrics;
}(React.Component));
Metrics.contextType = ApplicationContext;
export default injectIntl(Metrics);
